// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Highlighted day with blue background */
.highlighted-day {
  background-color: rgb(62, 110, 222) !important;
  color: white !important;
  height: 100%;
}

/* Optional: Add a hover effect for highlighted days */
.highlighted-day:hover {
  background-color: rgb(133, 147, 171);
}

/* Task count styling */
.task-count {
  font-size: 0.8rem;
  color: white; /* Ensure contrast on blue background */
  text-align: center;
}


.action-button-with-outline{
  padding: 2px 3px;
  margin-right: 5px;
  border: none; 
  background-color: transparent;
  color: rgb(236, 134, 26);

  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

.action-button-with-outline:hover{
  background-color: rgba(150, 214, 241, 0.87);
}

.action-button:hover {
  background-color: rgb(236, 134, 26);
  color: white;
}
.submit-button {
    
  border: none;
  background-color: #ff6f61;
  color: white;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  outline: none;
  height: 30px !important;
  padding: 0px 10px;
}

.submit-button:hover {
  outline: none;
  background-color: #e65c54;
}

.submit-button2 {
  
  border: none;
  background-color: #fff;
  color: #ff6f61;
  border-radius: 5px;
  border: 1px solid #ff6f61;
  cursor: pointer;
  transition: background-color 0.3s ease;
  outline: none;
  height: 30px !important;
}



.submit-button2:hover {
  background-color: #ff6f61;
  color: white;
}


.btn_complete_model-warning {
  background-color: #ff6f61;
  outline: none !important;
  border: none;

  color: white !important;
  
}

.btn_complete_model-warning:hover {
  background-color: #cb720b !important;
  color: #fff !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/DashboardImplementor/component/calender.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,8CAA8C;EAC9C,uBAAuB;EACvB,YAAY;AACd;;AAEA,sDAAsD;AACtD;EACE,oCAAoC;AACtC;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,YAAY,EAAE,uCAAuC;EACrD,kBAAkB;AACpB;;;AAGA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,6BAA6B;EAC7B,wBAAwB;;EAExB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;AACA;;EAEE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,sCAAsC;EACtC,aAAa;EACb,uBAAuB;AACzB;;;;AAIA;EACE,yBAAyB;EACzB,YAAY;AACd;;;AAGA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,YAAY;;EAEZ,uBAAuB;;AAEzB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB","sourcesContent":["/* Highlighted day with blue background */\n.highlighted-day {\n  background-color: rgb(62, 110, 222) !important;\n  color: white !important;\n  height: 100%;\n}\n\n/* Optional: Add a hover effect for highlighted days */\n.highlighted-day:hover {\n  background-color: rgb(133, 147, 171);\n}\n\n/* Task count styling */\n.task-count {\n  font-size: 0.8rem;\n  color: white; /* Ensure contrast on blue background */\n  text-align: center;\n}\n\n\n.action-button-with-outline{\n  padding: 2px 3px;\n  margin-right: 5px;\n  border: none; \n  background-color: transparent;\n  color: rgb(236, 134, 26);\n\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.action-button-with-outline:hover{\n  background-color: rgba(150, 214, 241, 0.87);\n}\n\n.action-button:hover {\n  background-color: rgb(236, 134, 26);\n  color: white;\n}\n.submit-button {\n    \n  border: none;\n  background-color: #ff6f61;\n  color: white;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  outline: none;\n  height: 30px !important;\n  padding: 0px 10px;\n}\n\n.submit-button:hover {\n  outline: none;\n  background-color: #e65c54;\n}\n\n.submit-button2 {\n  \n  border: none;\n  background-color: #fff;\n  color: #ff6f61;\n  border-radius: 5px;\n  border: 1px solid #ff6f61;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  outline: none;\n  height: 30px !important;\n}\n\n\n\n.submit-button2:hover {\n  background-color: #ff6f61;\n  color: white;\n}\n\n\n.btn_complete_model-warning {\n  background-color: #ff6f61;\n  outline: none !important;\n  border: none;\n\n  color: white !important;\n  \n}\n\n.btn_complete_model-warning:hover {\n  background-color: #cb720b !important;\n  color: #fff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
